import { render, staticRenderFns } from "./CreateTable.vue?vue&type=template&id=2554d873&scoped=true"
import script from "./CreateTable.vue?vue&type=script&lang=js"
export * from "./CreateTable.vue?vue&type=script&lang=js"
import style0 from "./CreateTable.vue?vue&type=style&index=0&id=2554d873&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2554d873",
  null
  
)

export default component.exports